"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var effects_1 = require("redux-saga/effects");
var paymentState_1 = require("../states/paymentState");
var paymentsService_1 = require("../services/paymentsService");
var authSelectors_1 = require("../selectors/authSelectors");
var settingsSelectors_1 = require("../selectors/settingsSelectors");
var i18n_1 = __importDefault(require("../i18n"));
var reportErrorsToInstrumentation_1 = __importStar(require("../helper/reportErrorsToInstrumentation"));
var authState_1 = require("../states/authState");
var utils_1 = require("../helper/utils");
function fetchPaymentsEffect(action) {
    var token, data, e_1, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 11]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(paymentsService_1.fetchPaymentsService, action.payload, token)];
            case 2:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(paymentState_1.paymentsActions.fetchPaymentsSuccess(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 11];
            case 4:
                e_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (e_1 && e_1.response && e_1.response.status && e_1.response.status === 404) {
                    errorMsg = (0, i18n_1.default)(language).common.errorGetData;
                }
                if (!(0, utils_1.unauthorizedError)(e_1)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, (0, effects_1.put)(paymentState_1.paymentsActions.fetchPaymentsFailure(errorMsg))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_1, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchPaymentsEffect.name))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function fetchPaymentsHistoryEffect(action) {
    var token, data, e_2, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 11]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token) {
                    throw Error("Missing token");
                }
                return [4 /*yield*/, (0, effects_1.call)(paymentsService_1.fetchPaymentsHistoryService, action.payload[0], action.payload[1], action.payload[2], action.payload[3], action.payload[4], action.payload[5], action.payload[6], token)];
            case 2:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(paymentState_1.paymentsActions.fetchPaymentsHistorySuccess(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 11];
            case 4:
                e_2 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (e_2 && e_2.reponse && e_2.response.status && e_2.response.status === 404) {
                    errorMsg = (0, i18n_1.default)(language).common.errorGetData;
                }
                if (!(0, utils_1.unauthorizedError)(e_2)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, (0, effects_1.put)(paymentState_1.paymentsActions.fetchPaymentsHistoryFailure(errorMsg))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_2, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchPaymentsHistoryEffect.name))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function processPaymentEffect(action) {
    var token, data, e_3, language, errorMsg, errorType;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _b.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(paymentsService_1.processPaymentService, action.payload.customerAccountId, action.payload.brandId, token)];
            case 2:
                data = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)(paymentState_1.paymentsActions.processPaymentSuccess(data))];
            case 3:
                _b.sent();
                return [3 /*break*/, 8];
            case 4:
                e_3 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_b.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                errorType = 500;
                if (((_a = e_3 === null || e_3 === void 0 ? void 0 : e_3.response) === null || _a === void 0 ? void 0 : _a.status) === 412) {
                    errorMsg = (0, i18n_1.default)(language).payment.errors.clientCutOff;
                    errorType = 412;
                }
                if (e_3['response'] && e_3['response']['status'] === 404) {
                    errorMsg = (0, i18n_1.default)(language).payment.errors.noPayment;
                    errorType = 404;
                }
                return [4 /*yield*/, (0, effects_1.put)(paymentState_1.paymentsActions.processPaymentFailure(errorMsg, errorType))];
            case 6:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_3, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, processPaymentEffect.name))];
            case 7:
                _b.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function updatedirectdebitOptionsEffect(action) {
    var token, response, nextPayment, e_4, language, errorMsg;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _c.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(paymentsService_1.updatedirectdebitOptionsService, action.payload.customerAccountId, action.payload.amount, action.payload.directDebitDay, token)];
            case 2:
                response = _c.sent();
                nextPayment = void 0;
                if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.scheduledInstalmentDto) {
                    nextPayment = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.scheduledInstalmentDto;
                }
                else {
                    nextPayment = {
                        periodicDebitSchedulerId: "",
                        withdrawalDate: "",
                        amount: action.payload.amount,
                        accountId: "",
                        reference: "",
                        directDebitDay: action.payload.directDebitDay
                    };
                }
                return [4 /*yield*/, (0, effects_1.put)(paymentState_1.paymentsActions.updatedirectdebitOptionsSuccess(nextPayment))];
            case 3:
                _c.sent();
                return [3 /*break*/, 8];
            case 4:
                e_4 = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_c.sent()).language;
                errorMsg = null;
                if (e_4['response'] && e_4['response']['status'] === 422) {
                    errorMsg = (0, i18n_1.default)(language).forgetPasswordScreen.stepSendEmail.errorMultipleChangeInYear;
                }
                else if (e_4['response'] && e_4['response']['status'] === 409) {
                    errorMsg = (0, i18n_1.default)(language).forgetPasswordScreen.stepSendEmail.errorPendingAOtherDemande;
                }
                else {
                    errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                }
                return [4 /*yield*/, (0, effects_1.put)(paymentState_1.paymentsActions.updatedirectdebitOptionsError(errorMsg))];
            case 6:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_4, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, updatedirectdebitOptionsEffect.name))];
            case 7:
                _c.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function isUpdatableDirectDebitOptionsEffect(action) {
    var token, e_5, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(paymentsService_1.isUpdatableDirectDebitOptionsService, token, action.payload)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(paymentState_1.paymentsActions.isUpdatableDirectDebitOptionsSuccess())];
            case 3:
                _a.sent();
                return [3 /*break*/, 8];
            case 4:
                e_5 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = null;
                if (e_5['response'] && e_5['response']['status'] === 422) {
                    errorMsg = (0, i18n_1.default)(language).forgetPasswordScreen.stepSendEmail.errorMultipleChangeInYear;
                }
                else if (e_5['response'] && e_5['response']['status'] === 409) {
                    errorMsg = (0, i18n_1.default)(language).forgetPasswordScreen.stepSendEmail.errorPendingAOtherDemande;
                }
                else {
                    errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                }
                return [4 /*yield*/, (0, effects_1.put)(paymentState_1.paymentsActions.isUpdatableDirectDebitOptionsFailure(errorMsg))];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_5, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, isUpdatableDirectDebitOptionsEffect.name))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function paymentsEffects() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(paymentState_1.paymentsActions.fetchPayments.type, fetchPaymentsEffect)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(paymentState_1.paymentsActions.fetchPaymentsHistory.type, fetchPaymentsHistoryEffect)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(paymentState_1.paymentsActions.processPayment.type, processPaymentEffect)];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(paymentState_1.paymentsActions.updatedirectdebitOptions.type, updatedirectdebitOptionsEffect)];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(paymentState_1.paymentsActions.isUpdatableDirectDebitOptions.type, isUpdatableDirectDebitOptionsEffect)];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.default = paymentsEffects;
